import React from "react";
import { Popover } from "@vapor/react-material/Popover";
import { ListItemButton } from "@vapor/react-material/ListItemButton";
import { List } from "@vapor/react-material/List";
import { Button } from "@vapor/react-material/Button";
import { ListItemText } from "@vapor/react-material/ListItemText";
import VaporIcon from "@vapor/react-icons/VaporIcon";
import { faPen, faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import { Props } from "../../types";

const CustomPopover:React.FC<Props>= ({ anchorEl, onClose }) => {
  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      <List disablePadding sx={{ width: 240 }}>
        <ListItemButton>
          <ListItemText primary="Rinomina" />
          <Button>
            <VaporIcon icon={faPen} color="interactive" />
          </Button>
        </ListItemButton>
        <ListItemButton component="a">
          <ListItemText primary="Elimina" />
          <Button>
            <VaporIcon icon={faTrashCan} color="critical" />
          </Button>
        </ListItemButton>
      </List>
    </Popover>
  );
};

export default CustomPopover;

